import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-test-transaction',
 standalone:false,
  templateUrl: './test-transaction.component.html',
  styleUrl: './test-transaction.component.scss'
})
export class TestTransactionComponent implements OnInit, OnDestroy {
  visible = false;
  displayDialog = false;
  selectedUser: any;
  filteredUser: any[];
  selectedUserList: any[] = []
  routeList = [
    //     {
    //     "user_rank": "Captain",
    //     "user_first_name": "John",
    //     "user_first_last_name": "Smith",
    //     "user_personal_number": 1001,
    //     "user_designation": "Operations Manager",
    //     "user_directorate_unit": "Logistics",
    //     "user_role": "Admin"
    // },
    // {
    //     "user_rank": "Lieutenant",
    //     "user_first_name": "Sarah",
    //     "user_first_last_name": "Johnson",
    //     "user_personal_number": 1002,
    //     "user_designation": "Intelligence Officer",
    //     "user_directorate_unit": "Intelligence",
    //     "user_role": "Editor"
    // },{
    //   "user_rank": "Major",
    //   "user_first_name": "David",
    //   "user_first_last_name": "Brown",
    //   "user_personal_number": 1003,
    //   "user_designation": "Security Specialist",
    //   "user_directorate_unit": "Security",
    //   "user_role": "Reviewer"
    // },
    // {
    //   "user_rank": "Corporal",
    //   "user_first_name": "Maria",
    //   "user_first_last_name": "Ramirez",
    //   "user_personal_number": 1004,
    //   "user_designation": "HR Coordinator",
    //   "user_directorate_unit": "Human Resources",
    //   "user_role": "User"
    // },
  ]
  steps: any;
  proposalId: any;
  cols: any[] = [
    { field: 'user.first_name', header: 'First Name', filterType: 'text' },
    { field: 'user.last_name', header: 'Last Name', filterType: 'text' },
    { field: 'proposal_step.name', header: 'Proposal Step Name', filterType: 'text' },
    { field: 'role.name', header: 'Role', filterType: 'text' },

  ];
  routeForm: FormGroup;
  proposalName: any;
  MasterData: any;
  phaseId: any;
  schemeId: any;
  private subscriptions = new Subscription();
  userID: any;
  navigate_Step: any
  unitList = [];
  userListCopy = [];
  filteredRouteList: any[] = [];
  filteredSteps: any;
  unitListN: any;
  constructor(private api: ApiService, private route: ActivatedRoute, private messageService: MessageService, private fb: FormBuilder,) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      const proposalName = params['name'];
      const phase = params['phase'];
      const scheme = params['scheme'];
      const step = params['step'];
      this.navigate_Step = step;
      this.proposalId = id;
      this.proposalName = proposalName;
      this.phaseId = phase
      this.schemeId = scheme
      this.onUserGuide('process')

    });
    const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?phase_id=${this.phaseId}`).subscribe(res => {
      this.steps = res;
       this.filteredSteps = this.steps?.filter(s => !s.skipped) || [];
      // this.activeIndex = res[0]?.code
      // this.stapName = res[0];
      const index = res.findIndex(item => item.id == this.navigate_Step) || 0;
      if (index == -1) {
        this.stapName = res[0];
        this.activeIndex = res[0].code
      } else {
        this.stapName = res[index];
        this.activeIndex = res[index].code
      }
      if (this.stapName) {
        this.onActiveIndexChange(this.stapName)
        //  this.getUsers();
      }
      //  this.getpermDetails();
    });
    this.subscriptions.add(sub);
    // this.routeForm = this.fb.group({
    //   step: ['', Validators.required],
    //   role: ['', Validators.required],
    //   user: ['', Validators.required],
    //   // unit: ['', Validators.required],
    //   level: ['', Validators.required],
    //   approved: [false, Validators.required]
    // });
    this.routeForm = this.fb.group({
  step: [null, Validators.required],
  role: [null, Validators.required],
  user: [null, Validators.required],
  // unit: [null, Validators.required],
  level: [null, Validators.required],
  approved: [false]
});

    this.ongetmasterData()
     // Animate nodes on init (similar to useEffect)
    this.timelineData.forEach((item, index) => {
      setTimeout(() => {
        this.animatedNodes.add(item.id);
      }, index * 200);
    });
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  activeIndex = 'R-ND';
  stapName: any;
  activeSeq = 1
  onActiveIndexChange(event: any) {
    //console.log('change', event.sequence)
    this.activeIndex = event.code;
    this.activeSeq = event.sequence
    this.stapName = event;
    this.onUserGuide('process')
    this.getpermDetails();
     this.getUsers();
     this.getworkflowlogs()
    // if (this.activeIndex == 'R-RFP-SOC') {
    //   const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?phase_id=${this.phaseId}`).subscribe(res => {
    //     this.steps = res;
    //     this.activeIndex = res[9]?.code
    //     this.stapName = res[9];
    //   });
    //   this.subscriptions.add(sub);
    // }
  }
  handlePOCChange(value: boolean): void {
    //console.log('POC Required:', value);
    const pocStep = this.steps.find(step => step.code === 'R-POC');
    if (pocStep) {
      pocStep.skipped = !value;
      //console.log('Updated POC step:', pocStep);
      this.steps = [...this.steps];
    }
  }
  // goToNextStep() {
  //   //  this.activeIndex++;
  //   const currentIndex = this.steps.findIndex(step => step.code === this.activeIndex);
  //   // Look for next non-skipped step
  //   for (let i = currentIndex + 1; i < this.steps.length; i++) {
  //     if (!this.steps[i].skipped) {
  //       this.activeIndex = this.steps[i].code;
  //       this.stapName = this.steps[i];  // If you use stapName in component bindings
  //       break;
  //     }

  //   }
  //   this.activeSeq = currentIndex;
  //   this.getpermDetails();
  // }
  goToNextStep() {
    const currentIndex = this.steps.findIndex(step => step.code === this.activeIndex);
    const nextStep = this.steps.slice(currentIndex + 1).find(step => !step.skipped);

    if (nextStep) {
      //console.log('Navigating to next step:', nextStep.sequence, nextStep.code);
      // Delay to prevent double triggering
      setTimeout(() => {
        this.onActiveIndexChange(nextStep);
      }, 0);
    } else {
      console.warn('No next step found.');
    }
  }
  userGuide: string;
  onUserGuide(event: string) {
    this.userGuide = event;

    if (this.userGuide == 'user') {
      this.getUsers();
    }
  }




  // user configration
  stagesList: any[] = []
  editeRoute() {
    this.visible = true;
    this.getRoleList();
    this.getUnit()
    this.getUserList();
    const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`).subscribe((res: any) => {
      this.stagesList = res
      this.routeForm.get('step')?.setValue(this.stapName.id);
      this.getProposalWorkflow(this.stapName.id);
    });
    this.subscriptions.add(sub);
  }
  getProposalWorkflow(id: any) {
    this.proposalData = [];
    const sub = this.api.getAPI(`/transaction/copy/proposal-workflow/?proposal_step_id=${id}`).subscribe((res: any) => {
      // //console.log(res)
      this.proposalData = res.data;
    });
    this.subscriptions.add(sub);
  }
  onSelect(event: any) {
    //console.log(event);
    this.selectedUserList.push(event.value);
    this.selectedUser = null;
  }

  filterUser(event: any) {
    let query = event.query.toLowerCase();

    this.filteredUser = this.routeList.filter(vendor =>
      vendor.user_rank.toLowerCase().includes(query) ||
      vendor.user_first_name.toLowerCase().includes(query) ||
      vendor.user_directorate_unit.toLowerCase().includes(query) ||
      vendor.user_role.toLowerCase().includes(query)

    );
  }
  DocName: string;
  pdfdata: any;
  generatePDF(event: any) {
    this.pdfdata = event;
    this.displayDialog = true;
  }

  isHTMLorText(input: any): boolean {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    // If the input contains HTML tags, return true (HTML), else false (Plain text)
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
  }
  saveVersion() {
    const data = document.getElementById('printSection')?.innerHTML;

    if (!data) {
      console.error("Missing required data for saving version.");
      return;
    }
    const payload = {
      proposal_step: this.stapName.id,
      name: this.DocName,
      paragraph: data
    };

    const sub = this.api.postAPI(this.pdfdata.url, payload).subscribe({
      next: (res) => {
        this.DocName = ''
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Version saved successfully' });
      },
      error: (err) => {
        console.error("Error saving version:", err);
      }
    });
  }
  getUsers() {
    this.routeList = [];
    const sub = this.api
      .getAPI(`/transaction/copy/proposal-workflow/?proposal_step_id=${this.stapName.id}`)
      .subscribe((res: any) => {
        this.getLogs()
        const usersMap = new Map();
        const sortedData = res.data.sort((a: any, b: any) => a.sequence - b.sequence);

        for (const item of sortedData) {
          const userId = item.user?.id;
          const roleId = item.role?.id;
          if (userId && roleId) {
            const compositeKey = `${userId}_${roleId}`;
            if (!usersMap.has(compositeKey)) {
              usersMap.set(compositeKey, item);
            }
          }
        }

        this.routeList = Array.from(usersMap.values());
         this.filteredRouteList = this.routeList.filter(member => 
    member.role.name !== 'Commenter'
  );
      });

    this.subscriptions.add(sub);
  }
  currentMatch: any = null;
// Component methods
getLogs() {
  this.api.getAPI(`/transaction/proposal-workflow-log/${this.stapName.id}/`)
    .subscribe((res: any) => {
      this.currentMatch = res.current_step;
      // this.cdr.detectChanges();
    });
}

// These methods should exist in your component
get matchedIndex(): number {
  if (!this.currentMatch) return -1;
  return this.filteredRouteList.findIndex(member => 
    member.user?.id === this.currentMatch.user?.id && 
    member.role?.id === this.currentMatch.role?.id
  );
}

isInProgressPath(member: any, index: number): boolean {
  const matchIdx = this.matchedIndex;
  return matchIdx >= 0 && index <= matchIdx;
}

isConnectorActive(index: number): boolean {
  const matchIdx = this.matchedIndex;
  return matchIdx >= 0 && index < matchIdx;
}

// Check if connector should be active (before matched index)
isConnectorInProgressPath(index: number): boolean {
  const matchIdx = this.matchedIndex;
  return matchIdx >= 0 && index < matchIdx;
}

// Only show connector if not last and next isn't Commenter
shouldShowConnector(member: any, index: number, last: boolean): boolean {
  if (last || member.role.name === 'Commenter') return false;
  const nextItem = this.routeList[index + 1];
  return !(nextItem && nextItem.role.name === 'Commenter');
}
  proposalData: any;
  roleList = []
  userList = []
  onrouteFormSubmit() {
    console.log(this.routeForm.value)
    if (this.routeForm.invalid) return;

    this.routeForm.get('step')?.setValue(this.stapName.id);

    const formValue = this.routeForm.value;
    const selectedUser = this.userList.find(u => u.id === formValue.user);

    const payload = {
      status: 1,
      sequence: this.routeForm.get('level')?.value, // Convert level input to number
      proposal_step: formValue.step,
      user: formValue.user,
      role: formValue.role,
       unit: selectedUser ? selectedUser.unit?.id : null,
      is_final_approve: formValue.approved === true
    };
    const sub = this.api.postAPI(`/transaction/proposal-workflow/`, payload).subscribe({
      next: (res: any) => {
        // this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${formValue.step}`).subscribe((res: any) => {
        //   this.proposalData = res;
        //   this.visible = false;

        // });
        this.visible = false;
        this.getUsers();
        this.routeForm.reset();
        // this.addProposalVisible = false;
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.detail || 'Something went wrong while updating the mapping.',
        });
      }
    });
    this.subscriptions.add(sub);
  }
  getRoleList() {
    const sub = this.api.getAPI('/access/user-roles/').subscribe((res: any) => {
      let rolePriority
      if (this.isIRA) {
        rolePriority = ['REC', 'APP']
      } else {
        rolePriority = ['INT', 'REC', 'APP'];  // desired order
      }
      const resp = res.data;

      // Filter and sort
      this.roleList = resp
        .filter(role => rolePriority.includes(role.code))
        .sort((a, b) => rolePriority.indexOf(a.code) - rolePriority.indexOf(b.code));
    });
  }
  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
      this.userListCopy = [...this.userList]
    })
    this.subscriptions.add(sub);
  }
  getUnit() {
     let currentUnitId  = sessionStorage.getItem('unit_id');
     console.log("unit" , currentUnitId )
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
      this.unitListN = res.data.filter((u: any) => u.id != Number(currentUnitId));
      console.log("unitlist" , this.unitListN)
    })
    this.subscriptions.add(sub);
  }
  onRoleChange(event: any) {
    // this.roleID = event.value;
    this.tryFetchingSequence();
  }

  onUserChange(event: any) {
    // this.userID = event.value;
    this.routeForm.get('step')?.setValue(this.stapName.id);
    this.tryFetchingSequence();
  }
  onUnitChange(event: any) {
    let unit_id = event.value
    this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
  tryFetchingSequence() {
    const step = this.routeForm.get('step').value;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    console.log(step , role , user)
    if (step && role && user) {
      this.getSequence();
    }
  }

  getSequence() {
    const step = this.routeForm.get('step').value;
    const role = this.routeForm.get('role').value;
    const user = this.routeForm.get('user').value;
    const sub = this.api.getAPI(`/transaction/get-next-level/?proposal_step_id=${step}&role_id=${role}`)
      .subscribe((res: any) => {
        const sequenceValue = res.level ?? '';
        this.routeForm.get('level')?.patchValue(sequenceValue);
        console.log(this.routeForm.get('level')?.value)
      });
    this.subscriptions.add(sub);
  }

  getSteps() {
    const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/phase_id=${this.phaseId}`).subscribe(res => {
      this.steps = res;
      this.activeIndex = res[0].code
    })
    this.subscriptions.add(sub);
  }
  onStepChange(event: any) {
    const selectedStepId = event.value;
    const sub = this.api.getAPI(`/transaction/proposal-workflow?proposal_step_id=${selectedStepId}`).subscribe((res: any) => {
      //console.log(res)
      this.proposalData = res

    });
    this.subscriptions.add(sub);
  }
  IRA: any;
  isIRA = false
  IRAremarks: string;
  onIRA(event: any) {
    this.isIRA = true;
    this.IRA = event;
    if (this.step_details?.add_route_conf) {
      this.getRoleList();
      this.getUnit()
      this.getUserList();
      const sub = this.api.getAPI(`/transaction/proposals/${this.proposalId}/steps/?skipped=False&phase_id=${this.phaseId}`).subscribe((res: any) => {
        this.stagesList = res
        this.routeForm.get('step')?.setValue(this.stapName.id);
        this.getProposalWorkflow(this.stapName.id);
      });
      this.subscriptions.add(sub);
    }
    //console.log('ira', event)
  }
  submitIRA(ira_status: any) {
    if (this.IRA === 'Initiate') {
      //console.log(this.IRAremarks)
    }
    if (this.IRA === 'Approve') {
      //console.log(this.IRAremarks)
    }
    if (this.IRA === 'Recommend') {
      //console.log(this.IRAremarks)
    }
     if(this.step_details?.add_route_conf){
      this.onrouteFormSubmit()
    }
    let role_id = sessionStorage.getItem('user_role_id')
    const payload = {
      "proposal_step": this.stapName.id,
      // "role_id": role_id,
      "is_approved": ira_status,
      "remark": this.IRAremarks

    }
    this.isIRA = false;
    this.IRAremarks = ''
    const sub = this.api.postAPI(`/transaction/copy/proposal-ira-action/`, payload).subscribe((res: any) => {
      this.isEditable = false;
       console.log("3")
      this.getpermDetails();
      //  this.goToNextStep()
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Proposal added successfully' });

    })
    this.subscriptions.add(sub);

  }
  isEditable: boolean = false;
  step_details: any;
  externalComment:string = '';
  internalComment:string = '';


  getpermDetails() {
    const user_role_id = sessionStorage.getItem('user_role_id');
    let seq = parseInt(this.stapName.sequence)
    const role = sessionStorage.getItem('user_role_id');
    const sub = this.api.getAPI(`/transaction/copy/proposals/${this.proposalId}/steps/?phase_id=${this.phaseId}`)
      .subscribe((res: any) => {
        this.step_details = res[seq - 1];

        this.isEditable = (
          ((this.step_details.is_initiator || this.step_details.is_approver || this.step_details.is_recommender) &&
            this.step_details.can_edit) || role == '6'
        );
      });
    this.subscriptions.add(sub);
  }


  reportList: any[] = []
  getReportList() {
    this.reportList = []
    const sub = this.api.getAPI(`/revenue/need/version-control/?proposal_step=${this.step_details.id}&proposal_step__proposal=${this.proposalId}`).subscribe((res: any) => {
      this.reportList = res
    });
    this.subscriptions.add(sub);
  }
  documentList: any[] = []
  getDocumentList() {
    this.documentList = []
    const sub = this.api.getAPI(`/revenue/dms/documents/${this.schemeId}/${this.proposalId}/`).subscribe((res: any) => {
      this.documentList = this.prepareDocumentList(res)
    });
    this.subscriptions.add(sub);
  }
  prepareDocumentList(data: any): any[] {
    const docs: any[] = [];

    // Need Generation
    if (data.need_generation) {
      docs.push({
        name: 'Draft SOTR',
        url: data.need_generation.draft_sotr
      });

      data.need_generation.need_files.forEach((file: any, index: number) => {
        docs.push({
          name: `Need File ${index + 1}`,
          url: file.file
        });
      });
    }

    // AIP
    if (data.aip?.document) {
      docs.push({
        name: 'AIP Document',
        url: data.aip.document
      });
    }

    // QA Agency
    if (data.qa_agecy?.nomination_file?.length > 0) {
      data.qa_agecy.nomination_file.forEach((file: any, index: number) => {
        docs.push({
          name: `QA Agency File ${index + 1}`,
          url: file.file
        });
      });
    }

    // AON and SOC
    if (data.aon_soc) {
      if (data.aon_soc.aon) {
        docs.push({ name: 'AON', url: data.aon_soc.aon });
      }
      if (data.aon_soc.soc) {
        docs.push({ name: 'SOC', url: data.aon_soc.soc });
      }
    }

    // Meeting MoMs
    if (data.pre_rfp_meeting?.mom) {
      docs.push({ name: 'Pre-RFP Meeting MoM', url: data.pre_rfp_meeting.mom });
    }

    if (data.pre_bid_meeting?.mom) {
      docs.push({ name: 'Pre-Bid Meeting MoM', url: data.pre_bid_meeting.mom });
    }

    // Final Offer
    if (data.final_offer?.offer) {
      docs.push({ name: 'Final Offer', url: data.final_offer.offer });
    }

    // Drawings and Related Docs
    if (data.drawings_documents) {
      if (data.drawings_documents.drawing) {
        docs.push({ name: 'Drawing File', url: data.drawings_documents.drawing });
      }
      if (data.drawings_documents.document) {
        docs.push({ name: 'Document File (Drawings)', url: data.drawings_documents.document });
      }
    }

    // QAP & ATP
    if (data.qap_atp) {
      if (data.qap_atp.qap) {
        docs.push({ name: 'QAP File', url: data.qap_atp.qap });
      }
      if (data.qap_atp.document) {
        docs.push({ name: 'ATP Document', url: data.qap_atp.document });
      }
    }

    // FAT Report
    if (data.fats_prototype?.fat_report) {
      docs.push({ name: 'FAT Report', url: data.fats_prototype.fat_report });
    }

    // User Certificate
    if (data.user_certificate?.certificated) {
      docs.push({ name: 'User Certificate', url: data.user_certificate.certificated });
    }

    // Development Prototype
    if (data.development_prototype?.file) {
      docs.push({ name: 'Development Prototype', url: data.development_prototype.file });
    }

    // User Trials
    if (data.user_trials?.signed_documents) {
      docs.push({ name: 'User Trials (Signed Docs)', url: data.user_trials.signed_documents });
    }

    // Bulk Production
    if (data.bulk_production?.document) {
      docs.push({ name: 'Bulk Production Document', url: data.bulk_production.document });
    }

    return docs;
  }

  viewDocument(doc: any) {
    //console.log(doc)
    const url = environment.APIUrl + doc?.url;
    window.open(url, '_blank');
  }

  downloadDocument(doc: any) {
    const link = document.createElement('a');
    link.href = environment.APIUrl + doc?.url; // adjust to your key
    link.download = doc?.name || 'document';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  pdfconvert(htmlContent: string): void {
    const blob = new Blob([htmlContent], { type: 'text/html' });

    const url = window.URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'report.html'; // Or give dynamic filename
    anchor.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
  }




  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  scrollLeft(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
  }
  ongetmasterData() {
    const sub = this.api.getAPI(`/master/master-data/`).subscribe((res: any) => {
      this.MasterData = res.data;
      this.MasterData = this.MasterData.map(item => ({
        id: item?.id,
        name: item?.name,
        paragraph_1: item.paragraph_1,
        paragraph_2: item.paragraph_2,
        style: item.css_file_url,
        criteria_list: JSON.stringify(item.criteria_list, null, 2) // pretty JSON format
      }));
    });
    this.subscriptions.add(sub);
  }
  getStepNumber(step: any): number {
    let count = 0;
    for (let s of this.steps) {
      if (!s.skipped) {
        count++;
      }
      if (s === step) {
        return count;
      }
    }
    return 0; // fallback
  }
  isStepDisabled(index: number): boolean {
    const currentStepIndex = this.steps.findIndex(step => step.code === this.activeIndex);

    // Disable future steps unless current step is INITIATED
    return index > currentStepIndex && this.steps[currentStepIndex]?.step_status !== 'INITIATED';
  }
  canNavigateTo(step: any): boolean {
    if (step.code === this.activeIndex) {
      return true; // current step is clickable (but will do nothing)
    }

    return this.isStepCompleted(step); // only completed steps
  }


  onStepClick(step: any): void {
    if (step.code === this.activeIndex) {
      return; // do nothing if clicking on current step
    }

    if (this.isStepCompleted(step)) {
      // this.navigateToStep(step); // only backward allowed
      this.onActiveIndexChange(step)
    }
  }

  // isStepCompleted(step: any): boolean {
  //   const currentIndex = this.steps.findIndex(s => s.code === this.activeIndex);
  //   const stepIndex = this.steps.findIndex(s => s.code === step.code);

  //   return stepIndex < currentIndex; // step is before current → completed
  // }

  navigateToStep(step: any): void {

    if (step.code === this.activeIndex) {
      return; // current step - do nothing
    }

    if (!this.isStepCompleted(step)) {
      return; // future step - prevent navigation
    }
    this.activeIndex = step.code;
  }
  viewSignVisible:boolean = false;
  signData:any
  viewSignature(){
    this.api.getAPI(`/transaction/proposal-workflow-log/${this.stapName.id}/`)
    .subscribe((res: any) => {
      this.signData = res.workflows;
      // this.cdr.detectChanges();
       console.log('pd' , this.signData)
    });
   
this.viewSignVisible = true
  }
    getInitials(name: string = ''): string {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  }

  getQRData(comment: any): string {
    console.log(comment)
    return JSON.stringify({
      id: comment.id,
      created_by: {
        name:
          comment.user?.first_name + ' ' + comment.user?.last_name,
        email: comment.user?.email,
      },
      code: comment.code,
    });
  }

  displayDialogN = false;
  shareType: string | null = null;
   selectedUserN: any;
  permissionType: string | null = null;
  selectedUnit: any;
    openDialog() {
    this.displayDialogN = true;
    this.getUserListN();
    this.getUnit()
    this.resetForm();
  }
  userListN:any
  getUserListN() {
  const unitId = Number(sessionStorage.getItem('unit_id'));

  const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
   let user = res.data;

    // Filter based on unit_id
    this.userListN = user.filter((user: any) => {
      return user.unit?.id === unitId;
    });
  });

  this.subscriptions.add(sub);
}

    resetForm() {
    this.shareType = null;
    this.selectedUserN = null;
    this.permissionType = null;
    this.selectedUnit = null;
  }
saveSelection() {
  const payload: any = {
    proposal_step: this.stapName.id, // Ensure this is defined in your component
    is_final_approve: false,
    route_type: this.shareType
  };

  if (this.shareType === 'internal') {
    payload.user = this.selectedUserN?.id;
    payload.unit = this.selectedUserN?.unit?.id || null; // if needed
    payload.flag = 1;
    payload.permission_type = this.permissionType;
    payload.remark = this.internalComment
  }

  if (this.shareType === 'external') {
    payload.unit = this.selectedUnit?.id;
     payload.remark = this.externalComment
  }

  console.log('Payload to submit:', payload);

  const sub = this.api.postAPI('/transaction/copy/proposal-workflow/', payload).subscribe({
    next: (res) => {
      console.log('Response:', res);
      // Optionally close dialog or show success
      this.displayDialogN = false;
      // this.getProposalWorkflow(this.stapName.id)
      this.getworkflowlogs()
    },
    error: (err) => {
      console.error('Error submitting workflow:', err);
      // Handle errors appropriately
    }
  });

  this.subscriptions.add(sub);
}
currentIndex = 0; // or bind it dynamically

get visibleSteps() {
  const visible = [];
  if (!this.filteredSteps || this.filteredSteps.length === 0) return visible;

  if (this.currentIndex > 0) visible.push(this.filteredSteps[this.currentIndex - 1]);
  visible.push(this.filteredSteps[this.currentIndex]);
  if (this.currentIndex < this.filteredSteps.length - 1)
    visible.push(this.filteredSteps[this.currentIndex + 1]);

  return visible;
}
navigate(direction: number) {
  const newIndex = this.currentIndex + direction;
  if (newIndex >= 0 && newIndex < this.filteredSteps.length) {
    this.currentIndex = newIndex;
    this.activeIndex = this.filteredSteps[newIndex].code;
    this.onActiveIndexChange(this.filteredSteps[newIndex])
  }
}

isCurrent(step: any): boolean {
  return step && this.filteredSteps[this.currentIndex].code === step.code;
}

isStepCompleted(step: any): boolean {
  if (!step) return false;

  const currentIndex = this.steps.findIndex(s => s.code === this.activeIndex);
  const stepIndex = this.steps.findIndex(s => s.code === step.code);

  // Step is completed only if it's before the current step AND approved
  return stepIndex < currentIndex && step.step_status === 'approved';
}
 expandedItems: { [key: number]: boolean } = {};
  animatedNodes: Set<number> = new Set();
  selectedNode: TimelineItem | null = null;
  
  // Sample data
  timelineData: TimelineItem[] = [ ];
  /** Gets the PrimeNG icon class for the status. */
  getStatusIconClass(status: TimelineItem['status']): string {
    switch (status) {
      case 'completed':
        return 'pi pi-check-circle'; // CheckCircle
      case 'working':
        return 'pi pi-spinner pi-spin'; // Activity / Spinner
      case 'pending':
        return 'pi pi-history'; // Clock
      default:
        return 'pi pi-history';
    }
  }

  /** Gets Bootstrap color class for the node background/border (Custom SCSS needed for exact gradients/shadows). */
  getStatusColorClass(status: TimelineItem['status'], userType: TimelineItem['userType']): string {
    // This uses Bootstrap color names for approximation
    if (userType === 'external') {
      switch (status) {
        case 'completed': return 'timeline-node-success'; // Emerald/Green
        case 'working': return 'timeline-node-primary'; // Blue
        case 'pending': return 'timeline-node-secondary'; // Slate/Gray
        default: return 'timeline-node-secondary';
      }
    } else { // internal
      switch (status) {
        case 'completed': return 'timeline-node-purple'; // Violet/Purple
        case 'working': return 'timeline-node-indigo'; // Indigo/Dark Blue
        case 'pending': return 'timeline-node-dark'; // Dark Slate/Gray
        default: return 'timeline-node-dark';
      }
    }
  }

  /** Gets Bootstrap badge color class for status badges. */
  getStatusBadgeColorClass(status: TimelineItem['status']): string {
    switch (status) {
      case 'completed': return 'bg-success-subtle text-success-emphasis border border-success-subtle';
      case 'working': return 'bg-primary-subtle text-primary-emphasis border border-primary-subtle';
      case 'pending': return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
      default: return 'bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle';
    }
  }

  /** Gets Bootstrap badge color class for priority badges. */
  getPriorityColorClass(priority: TimelineItem['priority']): string {
    switch (priority) {
      case 'critical': return 'bg-danger text-white';
      case 'high': return 'bg-warning text-dark';
      case 'medium': return 'bg-info text-dark';
      case 'low': return 'bg-success text-white';
      default: return 'bg-secondary text-white';
    }
  }

  /** Gets custom connector SCSS class. */
  getConnectorClass(currentStatus: TimelineItem['status'], index: number, total: number): string {
    if (index === total - 1) return '';
    
    switch (currentStatus) {
      case 'completed': 
        return 'timeline-connector connector-completed';
      case 'working': 
        return 'timeline-connector connector-working';
      default: 
        return 'timeline-connector connector-pending';
    }
  }

  /** Formats the timestamp. */
  formatTimestamp(timestamp: string | null): string {
    if (!timestamp) return 'Pending';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: '2-digit'
    }) + ' • ' + date.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }

  /** Toggles the expanded state of an item. */
  toggleExpanded(id: number): void {
    this.expandedItems[id] = !this.expandedItems[id];
  }

handleNodeClick(item: TimelineItem): void {
  this.selectedNode = this.selectedNode?.id === item.id ? null : item;
}

  /** Calculates overall progress percentage. */
  getProgressPercentage(): number {
    const completed = this.timelineData.filter(item => item.status === 'completed').length;
    return Math.round((completed / this.timelineData.length) * 100);
  }
  closeModal(): void {
  this.selectedNode = null;
}

  getworkflowlogs(){
    this.api.getAPI(`/transaction/timeline/?proposal_step=${this.stapName.id}`)
    .subscribe((res: any) => {
      console.log(res)
       this.timelineData = res.data.map((item: any) => ({
        ...item,
        description: `User type: ${item.userType}, Status: ${item.status}`,  // Optional fallback
        priority: this.getPriorityFromRole(item.internalUsers?.[0]?.role),   // You can define this method
      }));
    });
}
getPriorityFromRole(role: string): string {
  if (!role) return '';
  if (role.includes('Edit')) return 'High';
  if (role.includes('Comment')) return 'Medium';
  return 'Low';
}
}
interface InternalUser {
  name: string;
  status: 'completed' | 'working' | 'pending';
  timestamp: string | null;
  role: string;
  duration: string | null;
  permission:string;
}
interface TimelineItem {
  id: number;
  name: string;
  userType: 'external' | 'internal';
  status: 'completed' | 'working' | 'pending';
  timestamp: string | null;
  description: string;
  priority: 'critical' | 'high' | 'medium' | 'low';
  duration: string | null;
  hasInternal?: boolean;
  internalUsers?: InternalUser[];
  unit:string
  
}